module.exports = __webpack_public_path__ + "static/media/event2.bb72d5bd.jpeg";